// Define resource types and actions
export const CORNER_TYPES = {
  FORMULA: "formula",
  STYLE: "style",
  SATELLITE: "sat",
};

export const FORMULA_KEY_POINTERS = {
  SUM_LEVEL: "sumlevel",
  FORMULA: "formula",
  START: "start",
  SOURCE: "source",
  TARGET: "target",
  ACTIVE: "active",
};

export const SATELLITE_POINTERS = {
  START: "start",
  READ: "read",
};
